<script>
	import { fade, fly } from 'svelte/transition';
	import { onDestroy, onMount } from 'svelte';
	import { favoritesList } from '$lib/store/favorites';
	import DetailFavorite from './DetailFavorite.svelte';
	import { page } from '$app/stores';
	export let OpenFavorites;
	onMount(async () => {
		document.body.classList.add('modal-open');
		// window.scrollTo({ top: 0, behavior: 'smooth' });
	});
	onDestroy(() => {
		// Ваш код для закрытия модального окна
		document.body.classList.remove('modal-open');
	});
</script>

<div
	style="z-index: 1000"
	class="relative"
	aria-labelledby="slide-over-title"
	role="dialog"
	aria-modal="true"
>
	<!-- Background backdrop, show/hide based on slide-over state. -->
	<div class="fixed bg-custom-black opacity-70 inset-0" />

	<div
		transition:fly={{
			x: 200,
			duration: 500
		}}
		class="fixed inset-0"
	>
		<div class="absolute inset-0 overflow-hidden">
			<div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
				<div class="pointer-events-auto w-screen max-w-2xl">
					<div class="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
						<div class="px-4 sm:px-6">
							<div class="flex items-start justify-between">
								<h2 class="text-base font-semibold leading-6 text-gray-900" id="slide-over-title" />
								<div class="ml-3 flex h-7 items-center">
									<button
										on:click={() => {
											OpenFavorites = false;
										}}
										type="button"
										class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
									>
										<span class="sr-only">Close panel</span>
										<svg
											class="h-6 w-6"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											aria-hidden="true"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6 18L18 6M6 6l12 12"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div class="relative mt-6 flex-1 px-4 pt-[19px] sm:px-6">
							<div class="w-full">
								<h2 class="text-2xl text-custom-gray text-left">
									{#if $page.data.host === 'ARM'}
										Ֆավորիտներ
									{:else}
										Избранное
									{/if}
								</h2>
								{#if $favoritesList.length > 0}
									<div class="relative h-[80vh] overflow-y-auto mt-6 flex-1 px-4 sm:px-6">
										<!-- svelte-ignore a11y-no-redundant-roles -->
										<ul
											role="list"
											class="mt-6 text-sm font-medium text-gray-500 dark:text-gray-50"
										>
											{#each $favoritesList as item (item.item.id)}
												<DetailFavorite item={item.item} />
											{/each}
										</ul>
									</div>
								{:else}
									<div class="h-[60vh] w-full flex justify-center items-center">
										<h2 class="text-custom-gray text-2xl">
											{#if $page.data.host === 'ARM'}
												Դեռ ոչինչ չի ավելացվել ընտրյալներին
											{:else}
												В избранное еще ничего не добавлено
											{/if}
										</h2>
									</div>
								{/if}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
